import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { UserService } from './user.service';
export interface ExtensionDetailsDto {
  clientId: string;
  extensionDraftExtensionDate: Date | null;
  extensionAppliedOn: Date | null;
  isExtensionRequired?: boolean;
  status: string;
  stateId: string;
  locationId: string;
  branch: string;
  noticeNumber: string;
  draftExtensionApplicationfile: File | null;
}
@Injectable({
  providedIn: 'root'
})
export class NoticesServiceService {

  private entitySubject = new BehaviorSubject<{ text: string, value: string } | null>(null);
  entity$ = this.entitySubject.asObservable();
  private apiUrl = environment.apiUrl;
  private token: string;
  constructor(private http: HttpClient, private userService: UserService) {
    this.token = this.userService.getAccessToken();
  }


  getPendingAssignmentCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/PendingAssignmentCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getPendingActionCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/PendingActionCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getOverdueCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/OverdueCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getSMEOverdueCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/SMEOverdueCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getClosedCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/ClosedCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getPendingExtensionCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/PendingExtensionCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getResponsePendingCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/ResponsePendingCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getNoticeResponseSubmittedCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/NoticeResponseSubmittedCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getResponseSubmittedCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/ResponseSubmittedCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getTranslationPendingCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/TranslationPendingCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getExtensionSubmitionCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/ExtensionSubmitionCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getSubmissionPendingCount(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/SubmissionPendingCount?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetRole(UserId: number): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetRole?UserId=${UserId}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getNoticeDetails(Userid: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/NoticeDetails?Userid=${Userid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetNoticeData(Noticenumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetNoticeData?Noticenumber=${encodeURIComponent(Noticenumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetNoticeState(clientId: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetNoticeState?clientId=${clientId}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetNoticeClientList(UserId: number): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetNoticeClientList?UserId=${UserId}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getNoticeTypeList(): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/NoticeTypeList`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getSMETeamList(): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/SMETeamList`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getSDExecuterTeamList(): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/SDExecuterTeamList`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getGetNoticeLocation(State_code: string, Clientid: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetNoticeLocation?Status=A&State_code=${State_code}&Clientid=${Clientid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetNoticeBranchForClient(ClientID: string, State_code: string, Location_Code: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetNoticeBranchForClient?ClientID=${ClientID}&State_code=${State_code}&Location_Code=${Location_Code}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  getGetNoticeRisk(NoticeTypeid: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetNoticeRisk?NoticeTypeid=${NoticeTypeid}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  SaveNoticeDetails(value: any): Observable<HttpResponse<any>> {
    const body = {
      translationRequestDate: value.translationRequestDate,
      isTranslationRequired: value.isTranslationRequired,
      sme: value.sme,
      clientId: value.clientId,
      sdExecuter: value.sdExecuter,
      status: value.status,
      stateId: value.stateId,
      locationId: value.locationId,
      branch: value.branch,
      noticeNumber: value.noticeNumber,
      assignedBy: value.assignedBy
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/SaveNoticeDetails`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }
  UpdateNotice(value: any): Observable<HttpResponse<any>> {
    const body = {
      clientId: value.clientId,
      status: value.status,
      stateId: value.stateId,
      locationId: value.locationId,
      branch: value.branch,
      noticeNumber: value.noticeNumber,
      receiptMode: value.receiptMode,
      risk: value.risk,
      responseDueDate: value.responseDueDate,
      noticeReceivedDate: value.noticeReceivedDate,
      noticeTypeid: value.noticeTypeid,
      remarks: value.remarks
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/UpdateNotice`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  submitTranslationDetails(translationDetails: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/SubmitTranslationDetails`;
    return this.http.post(url, translationDetails, { headers: headers, observe: 'response' });
  }
  submitExtensionDetails(extensionDetails: ExtensionDetailsDto): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/Notices/SubmitExtensionDetails`;
    const formData: FormData = new FormData();
    formData.append('ClientId', extensionDetails.clientId);
    if (extensionDetails.extensionDraftExtensionDate) {
      formData.append('ExtensionDraftExtensionDate', extensionDetails.extensionDraftExtensionDate.toISOString());
    }
    if (extensionDetails.extensionAppliedOn) {
      formData.append('ExtensionAppliedOn', extensionDetails.extensionAppliedOn.toISOString());
    }
    formData.append('IsExtensionRequired', extensionDetails.isExtensionRequired ? 'true' : 'false');
    formData.append('Status', extensionDetails.status);
    formData.append('StateId', extensionDetails.stateId);
    formData.append('LocationId', extensionDetails.locationId);
    formData.append('Branch', extensionDetails.branch);
    formData.append('NoticeNumber', extensionDetails.noticeNumber);

    if (extensionDetails.draftExtensionApplicationfile) {
      formData.append('DraftExtensionApplicationfile', extensionDetails.draftExtensionApplicationfile, extensionDetails.draftExtensionApplicationfile.name);
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post(url, formData, { headers: headers, observe: 'response' });
  }
  saveExtension(extensionDetails: ExtensionDetailsDto): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/Notices/SaveExtensionDetails`;
    const formData: FormData = new FormData();
    formData.append('ClientId', extensionDetails.clientId);
    if (extensionDetails.extensionDraftExtensionDate) {
      formData.append('ExtensionDraftExtensionDate', extensionDetails.extensionDraftExtensionDate.toISOString());
    }
    if (extensionDetails.extensionAppliedOn) {
      formData.append('ExtensionAppliedOn', extensionDetails.extensionAppliedOn.toISOString());
    }
    formData.append('IsExtensionRequired', extensionDetails.isExtensionRequired ? 'true' : 'false');
    formData.append('Status', extensionDetails.status);
    formData.append('StateId', extensionDetails.stateId);
    formData.append('LocationId', extensionDetails.locationId);
    formData.append('Branch', extensionDetails.branch);
    formData.append('NoticeNumber', extensionDetails.noticeNumber);

    if (extensionDetails.draftExtensionApplicationfile) {
      formData.append('DraftExtensionApplicationfile', extensionDetails.draftExtensionApplicationfile, extensionDetails.draftExtensionApplicationfile.name);
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post(url, formData, { headers: headers, observe: 'response' });
  }
  NoticeDocumentsDetails(NoticeTypeId: number, NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/NoticeDocumentsDetails?NoticeTypeId=${NoticeTypeId}&NoticeNumber=${NoticeNumber}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }

  saveNoticeResponseBySME(data: any, file: File): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/Notices/SaveNoticeResponseBySME`;
    const formData: FormData = new FormData();
    formData.append('Status', data.Status);
    formData.append('NoticeDraftResponseDate', data.NoticeDraftResponseDate);
    formData.append('ClientId', data.ClientId);
    formData.append('StateId', data.StateId);
    formData.append('Branch', data.Branch);
    formData.append('LocationId', data.LocationId);
    formData.append('NoticeNumber', data.NoticeNumber);
    if (file) {
      formData.append('NoticeDraftResponseFile', file, file.name);
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post<any>(url, formData, { headers: headers, observe: 'response' });
  }
  saveSDTranslationDocument(data: any, file: File): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/Notices/SaveTranslationDocument`;
    const formData: FormData = new FormData();
    formData.append('TranslationDocumentUploadDate', data.TranslationDocumentUploadDate);
    formData.append('TranslationRequestDate', data.TranslationRequestDate);
    formData.append('IsTranslationRequired', data.IsTranslationRequired);
    formData.append('Status', data.Status);
    formData.append('ClientId', data.ClientId);
    formData.append('StateId', data.StateId);
    formData.append('LocationId', data.LocationId);
    formData.append('Branch', data.Branch);
    formData.append('NoticeNumber', data.NoticeNumber);
    if (file) {
      formData.append('TranslationDocumentFile', file, file.name);
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post<any>(url, formData, { headers: headers, observe: 'response' });
  }

  saveSDExtensionDocument(data: any, file: File): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/Notices/SaveExtensionDocument`;
    const formData: FormData = new FormData();
    formData.append('IsExtensionRequired', data.IsExtensionRequired);
    formData.append('ExtensionGrantedDate', data.ExtensionGrantedDate.toString());
    formData.append('ExtensionApplicationDate', data.ExtensionApplicationDate.toString());
    formData.append('Status', data.Status);
    formData.append('ClientId', data.ClientId);
    formData.append('StateId', data.StateId);
    formData.append('LocationId', data.LocationId);
    formData.append('Branch', data.Branch);
    formData.append('NoticeNumber', data.NoticeNumber);
    if (file) {
      formData.append('ExtensionAcknowledgementDocumentFile', file, file.name);
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post<any>(url, formData, { headers: headers, observe: 'response' });
  }
  saveSDNoticeResponse(data: any, file: File): Observable<HttpResponse<any>> {
    const url = `${this.apiUrl}/api/Notices/SaveNoticeResponse`;
    const formData: FormData = new FormData();
    formData.append('NoticeResponseSubmittedToDept', data.NoticeResponseSubmittedToDept);
    formData.append('Status', data.Status);
    formData.append('ClientId', data.ClientId);
    formData.append('StateId', data.StateId);
    formData.append('LocationId', data.LocationId);
    formData.append('Branch', data.Branch);
    formData.append('NoticeNumber', data.NoticeNumber);
    formData.append('NoticeClosureDate', data.NoticeClosureDate);
    if (file) {
      formData.append('NoticeResponseAcknowledgementFile', file, file.name);
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post<any>(url, formData, { headers: headers, observe: 'response' });
  }
  GetfilePath(Act: string, DocumentName: string, NoticeTypeId: number, NoticeNo: any, isMasterDoc: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetfilePath?Act=${Act}&DocumentName=${DocumentName}&NoticeTypeId=${NoticeTypeId}&NoticeNo=${NoticeNo}&Flag=${isMasterDoc}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  MailSentAfterNoticeAssignment(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailSentAfterNoticeAssignment?NoticeNumber=${NoticeNumber}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  SaveMasterDocument(noticeDocumentList: any[]): Observable<HttpResponse<any>> {
    if (!Array.isArray(noticeDocumentList)) {
      console.error('Expected noticeDocumentList to be an array, but received:', noticeDocumentList);
      throw new Error('noticeDocumentList must be an array');
    }

    const formData = new FormData();

    noticeDocumentList.forEach((item, index) => {
      if (item.upload) {
        formData.append('masterFiles', item.upload, item.upload.name);
      } else {
        formData.append(`masterFiles[${index}]`, '');
      }

      const clonedItem = { ...item };
      delete clonedItem.upload;

      formData.append(`NoticeDocumentList[${index}]`, JSON.stringify(clonedItem));
    });

    const url = `${this.apiUrl}/api/Notices/SaveMasterDocument`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`,
    });
    return this.http.post(url, formData, { headers: headers, observe: 'response' });
  }

  exportNoticeDetails(userId: any, flag: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/NoticeDetails_ExporttoExcel?Userid=${userId}&flag=${flag}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  exportNotice(userId: any, flag: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/Notice_ExporttoExcel?userid=${userId}&flag=${flag}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }


  setEntity(entity: { text: string, value: string }) {
    this.entitySubject.next(entity);
  }

  getEntity(): { text: string, value: string } | null {
    return this.entitySubject.getValue();
  }

  downloadNoticeDocument(Filepath: any): Observable<{ blob: Blob, filename: string }> {
    this.token = this.userService.getAccessToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/NoticeDocumentDownload?Filepath=${encodeURIComponent(Filepath)}`;
    return this.http.get(url, {
      headers: headers,
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (!contentDisposition) {
          console.error('Content-Disposition header is missing.');
          return { blob: response.body as Blob, filename: 'unknown' };
        }

        const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/);

        const filename = filenameMatch ? filenameMatch[1] : 'unknown';

        return {
          blob: response.body as Blob,
          filename: filename,

        };
      })
    );
  }

  mailSentAfterNoticeCreation(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailSentAfterNoticeCreation?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForTranslation(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForTranslation?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForExtension(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForExtension?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForResponsePending(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForResponsePending?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForNoticeResponseSubmitted(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForSubmitNoticeResponse?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForExtensionApplication(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForExtensionApplication?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForExtensionGranted(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForExtensionGranted?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForSubmissionPending(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForSubmissionPending?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForExtensionPending(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForExtensionPending?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  mailForSubmitNotice(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailForSubmitNotice?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  MailSentForNoticeAssignment(NoticeNumber: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/MailSentForNoticeAssignment?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  DeleteOtherMaterDocuments(ID: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/DeleteOtherMaterDocuments?ID=${ID}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetBranchdetails(BranchID: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetBranchdetails?BranchID=${BranchID}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
  GetTranslatedDocumentByNoticeID(NoticeNumber: any): Observable<{ blob: Blob, filename: string }> {
    this.token = this.userService.getAccessToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetTranslatedDocumentByNoticeID?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, {
      headers: headers,
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (!contentDisposition) {
          console.error('Content-Disposition header is missing.');
          return { blob: response.body as Blob, filename: 'unknown' };
        }

        const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/);

        const filename = filenameMatch ? filenameMatch[1] : 'unknown';

        return {
          blob: response.body as Blob,
          filename: filename,

        };
      })
    );
  }
   TranslateNoticeDocument(NoticeNumber: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/TranslateNoticeDocument?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }

  GetTranslationStatus(NoticeNumber: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.userService.getAccessToken()}`
    });
    const url = `${this.apiUrl}/api/Notices/GetTranslationStatus?NoticeNumber=${encodeURIComponent(NoticeNumber)}`;
    return this.http.get(url, { headers: headers, observe: 'response' });
  }
}
